import eventService from "./event.service";
import EventTypes from "../models/EventTypes";

export const MessageTypes = {
  Success: "success",
  Error: "error",
};

export default {
  showMessage: function (type, message) {
    eventService.triggerEvent(EventTypes.Message, {type, message});
  }
};
